import ConversationCounter from "./interfaces/conversation-counter-model"

export default class ConversationsCounterModel implements ConversationCounter {
    availableConversationsCount: number;
    monthlyConversationsLimit: number;
    spentMarketing: number;
    spentUtility: number;
    hasReachedReferralThreshold: boolean;

    constructor(x?: any) {
        if (typeof x === "object") {
            this.monthlyConversationsLimit = x.monthlyConversationsLimit;
            this.hasReachedReferralThreshold = x.hasReachedReferralThreshold;
            this.spentMarketing = x.spentMarketing;
            this.spentUtility = x.spentUtility;
            this.availableConversationsCount = x.availableConversationsCount;
        } else {
            this.monthlyConversationsLimit = 1000;
            this.hasReachedReferralThreshold = false;
            this.spentMarketing = 0;
            this.spentUtility = 0;
            this.availableConversationsCount = 0;
        }
    }
}